import { render, staticRenderFns } from "./ShareLinkWhatsapp.vue?vue&type=template&id=21bc1e46&scoped=true"
import script from "./ShareLinkWhatsapp.vue?vue&type=script&lang=js"
export * from "./ShareLinkWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bc1e46",
  null
  
)

export default component.exports